import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CustomFormlyFieldConfig } from '@app/core/interfaces/formly-forms.interface';
import { FormDefinitionService } from '@app/core/services/form-definition.service';

@Component({
  selector: 'formly-field-card-wrapper',
  templateUrl: './formly-field-card-wrapper.component.html',
  styleUrls: ['./formly-field-card-wrapper.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormlyModule,
  ],
})
export class FormlyFieldCardWrapperComponent extends FieldWrapper {
  private formDefinitionService = inject(FormDefinitionService);

  public hasVisibleChildren(): boolean {
    const flattenedFields = this.formDefinitionService.flattenFormFields(this.field.fieldGroup as CustomFormlyFieldConfig[] || []);
    return flattenedFields.some(f => !f.hide && f.type !== 'HIDDEN' && !f.props?.fieldArrayKey);
  }

  public getVisibleChildrenNames(): string[] {
    const flattenedFields = this.formDefinitionService.flattenFormFields(this.field.fieldGroup as CustomFormlyFieldConfig[] || []);
    return flattenedFields.filter(f => !f.hide && f.type !== 'HIDDEN' && !f.props?.fieldArrayKey).map(f => f.key as string || f.props!.label || 'Unnamed Field');
  }
}